"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query organizations(
    $query: OrganizationQueryInput
    $pagination: PaginationInput
  ) {
    organizations(query: $query, pagination: $pagination) {
      _id
      orgName
      createdAt
    }
  }
`;
exports.default = query;
//# sourceMappingURL=eventCalenderOrganizations.query.js.map